// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Zk130","buttonText":"Button_buttonText__aCP7u"};